import { useLingui } from "@lingui/react/macro";
import { FilterBanner } from "@/components/FilterBanner/FilterBanner";
import {
  useDailyOverviewFilterBannerItem,
  usePatientNameFilterActions,
} from "./DailyOverviewContext";

export const DailyOverviewFilterBannerSection = () => {
  const { t } = useLingui();
  const patientNameFilterItem = useDailyOverviewFilterBannerItem(t`Patient`);
  const { clearFilterValue } = usePatientNameFilterActions();

  return (
    <FilterBanner
      filters={[patientNameFilterItem]}
      onClearAllFilters={clearFilterValue}
    />
  );
};
